import React from 'react'
import './button-close.scss'
const ButtonClose = ({
  className = '',
  onClick = () => {},
  title = '',
}: {
  title?: string
  className?: string
  onClick: () => void
}) => {
  return (
    <button
      className={'f-button-close ' + className}
      onClick={onClick}
      title={title}
    ></button>
  )
}

export default ButtonClose
